export default __webpack_public_path__ + "static/media/10.965a7cea.jpg";